import script from "./ConfirmOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmOrder.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmOrder.vue?vue&type=style&index=0&id=32557c8f&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32557c8f"]])

export default __exports__